<template>
  <div class="new-section login-register">
    <div class="m-container">
      <div class="q-pa-md">
        <div class="q-gutter-y-md">
          <q-card flat>
            <div class="tabs-continer">
              <q-tabs v-model="tab" class="text-grey"  align="justify" narrow-indicator>
                <q-tab name="login" label="Login" />
                <q-tab name="register" label="Register" />
              </q-tabs>
            </div>
            <q-separator color="primary"></q-separator>

            <q-tab-panels v-model="tab" animated>
              <q-tab-panel name="login">
                <login @reactive="reactive"></login>
              </q-tab-panel>

              <q-tab-panel name="register">
                <regiister :reactivate="reactivate" :loginData="loginData" @codeResend="codeResend" @setLoginData="setLoginData"></regiister>
              </q-tab-panel>

            </q-tab-panels>
          </q-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "../components/auth/Login";
import Regiister from "../components/auth/Regiister";
import ContactUs from "../components/home/ContactUs";
import LinksFooter from "@/components/layouts/LinksFooter";
import TopFooter from "@/components/layouts/TopFooter";

export default {
  components: {TopFooter, LinksFooter, ContactUs, Regiister, Login},
  data() {
    return {
      tab: 'login',
      reactivate: false,
      loginData: null
    }
  },
  methods: {
    reactive(form) {
      this.tab = 'register';
      this.reactivate = true;
      this.loginData = form
    },
    codeResend() {
      this.reactivate = false;
    },
    setLoginData(data) {
      this.loginData = data
    }
  },
  mounted() {
    function Phone(name, age, email) {
      this.name = name;
      this.age = age;
      this.email = email;
      this.update_name = function (newName) {
       if(this.age < 20 ) {
         this.name = newName;
       }else {
        return `You Cant Do thank becouse your age is ${this.age}`;
       }
      }
    }

    let user = new Phone("khaled", 24, 'khaled.mohamed19967');
    console.log(user.name);
    user.update_name("mostafa");
    console.log(user.name);

  }
}
</script>

<style>
.q-tab--active {
  color: var(--mainColors) !important;
}

.q-tab__indicator {
  color: var(--mainColors)!important;
}

.tabs-continer {
  max-width: 307px;
  margin: auto;
}

.login-register hr {
  max-width: 307px;
  margin: auto;
}

.the-form .contact-us-form-body {
  max-width: 499px;
}


.the-form .form-body {
  margin-bottom: 25px;
}

.the-form .form-body form {
  padding: 25px 60px;
}


.the-form .form-body form > p {
  margin-bottom: 10px !important;
  text-align: left;
}

.the-form .form-body form p:nth-child(2) {
  color: var(--secondaryColors);
  font-weight: 500;
}

.the-form .form-body form label {
  margin: 10px 0px 0px;
  font-weight: 400;
}

.the-form .form-body form .submit {
  text-align: center;
}

.the-form .form-body form .the-button {
  margin: 33px 0px;
}

@media (max-width: 530px ) {

  .the-form .form-body form {
    padding: 0;
  }
}
</style>
